import {
  Component, OnInit, ViewChild, ElementRef, Input, Output,
  EventEmitter, HostBinding, ChangeDetectorRef, Optional, Injector, ViewContainerRef, ViewEncapsulation, LOCALE_ID, ReflectiveInjector, AfterViewChecked
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';

import { AppOptions, FrameworkService } from '@gsp-sys/rtf-common';
import { MessagerService } from '@farris/ui-messager';
import { LoadingService } from "@farris/ui-loading";
import { NotifyService } from '@farris/ui-notify';

import { FlowChart } from '../flow-chart/FlowChart';
import { UiFlowchartService } from '../services/ui-flowchart.service';
import { WFFlowchartService } from '../wf-flowchart.service';
import { CellStyleConfig } from '../entity/cell-style/CellStyleConfig';
import { ActivityInstanceSlim, ProcessInstance } from '../flow-chart/entity';
import { BsModalRef } from '@farris/ui-modal';

@Component({
  selector: 'wf-flowchart',
  templateUrl: './task-flowchart.component.html',
  styleUrls: ['./task-flowchart.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UIFlowchartComponent implements OnInit, AfterViewChecked {

  static func: any = null; // 消息监听处理方法
  @HostBinding('class') cls = 'd-flex flex-fill h-100';
  @ViewChild('iframe') iframe: ElementRef;
  @Output() modalHide = new EventEmitter<boolean>();
  procInstId: string;//流程实例id
  dataId: string;//表单id
  actDefId: string;//节点定义id
  ifForecast: string;//是否预测
  type: any; //type = 'process'查看流程日志；type = 'activity'，查看节点日志
  content: string; // bpmnModel
  actInstList: any[]; // 活动实例List
  transInsList: any[];  // 流转实例
  processInstance: any;
  fcHtml = window.document.location.origin + '/platform/runtime/wf/web/designer/flowchart.html?v=20221111';

  @Input() theme = 'viewFlowChart';
  @Input() processForecastPayload: any;
  dialog: BsModalRef;

  private _mode = 'complete';

  @Input()
  set mode(v: string) {
    this._mode = v;
    if (this._mode === 'simulation') {
      this.ifForecast = 'true';
      this.modeButton = this.service.getI18nValue('static.flowchart.complete');
    } else if (this._mode === 'complete') {
      this.modeButton = this.service.getI18nValue('static.flowchart.simulation');
    }
  }
  get mode() {
    return this._mode;
  }

  modeButton = this.service.getI18nValue('static.flowchart.simulation');
  typeList = [
    {
      value: 'complete', text: this.service.getI18nValue('static.flowchart.complete')
    },
    {
      value: 'simulation', text: this.service.getI18nValue('static.flowchart.simulation')
    }
  ];

  private message: MessagerService;
  private frameworkSvc: FrameworkService;

  @Input()
  set ProcInstId(procInstId: string) {
    if (procInstId) {
      this.procInstId = procInstId;
    }
  }

  @Input()
  set DataId(dataId: string) {
    if (dataId) {
      this.dataId = dataId;
    }
  }

  @Input()
  set ProcInstList(procInstList: ProcessInstance[]) {
    if (procInstList && procInstList.length) {
      this.procInstId = procInstList[0].id;
      this.procInstList = procInstList;
    }
  }

  @ViewChild("flowChartContainer") flowChartContainerER: ElementRef<HTMLDivElement>;
  @ViewChild("flowChartContainer", { read: ViewContainerRef })
  flowChartContainerVCR: ViewContainerRef;
  flowChart: FlowChart;
  localeId: string = "zh-CHS";
  loading: LoadingService;
  notify: NotifyService;
  procInstList: ProcessInstance[] = [];//流程实例list，多实例子流程使用
  curChildProcInst: ProcessInstance;//当前选中的流程

  flowChartContainerClientSize: {
    clientHeight?: number;
    clientWidth?: number;
  } = {};

  sequenceColorList = [//颜色分支线说明
    {
      colorClass: 'color-gey',
      label: 'completed'
    }, {
      colorClass: 'color-yellow',
      label: 'calculate'
    }, {
      colorClass: 'color-blue',
      label: 'default'
    }, {
      colorClass: 'color-red',
      label: 'suspend'
    }
  ]

  constructor(
    private sanitizer: DomSanitizer,
    private service: UiFlowchartService,
    private changeDetector: ChangeDetectorRef,
    private injector: Injector,
    @Optional() private chartService: WFFlowchartService,
  ) {
    this.message = this.injector.get(MessagerService);
    this.frameworkSvc = this.injector.get(FrameworkService);
    this.localeId = this.injector.get(LOCALE_ID, null) || this.localeId;
    this.loading = this.injector.get(LoadingService, null);
    if (this.loading == null) {
      const inject = ReflectiveInjector.resolveAndCreate([
        LoadingService
      ], this.injector);
      this.loading = inject.get(LoadingService, null);
    }
    this.notify = this.injector.get(NotifyService, null);
    if (this.notify == null) {
      const inject = ReflectiveInjector.resolveAndCreate([
        NotifyService
      ], this.injector);
      this.notify = inject.get(NotifyService, null);
    }
  }

  ngOnInit() {
    this.service.getFlowChartStyleConfig().subscribe((config: CellStyleConfig) => {
      setTimeout(() => {
        this.createFlowChart(config);
        this.viewFlowChart();
      }, 300);
    });
  }

  ngAfterViewChecked() {
    // 监听画布容器高度和宽度属性变化，发生变化时刷新画布
    if (this.flowChartContainerER == null || this.flowChartContainerER.nativeElement == null || this.flowChart == null) {
      return;
    }
    if (this.flowChartContainerClientSize.clientHeight != this.flowChartContainerER.nativeElement.clientHeight
      || this.flowChartContainerClientSize.clientWidth != this.flowChartContainerER.nativeElement.clientWidth
    ) {
      this.flowChartContainerClientSize = {
        clientHeight: this.flowChartContainerER.nativeElement.clientHeight,
        clientWidth: this.flowChartContainerER.nativeElement.clientWidth,
      };

      this.flowChart.refresh();
      this.flowChart.graph.sizeDidChange();
    }
  }

  createFlowChart(config: CellStyleConfig) {
    this.flowChart = new FlowChart(this.flowChartContainerER.nativeElement, config);
    this.flowChart.ngComp = this;
    this.flowChart.setLanguage(this.localeId);
  }

  viewFlowChart() {
    if (this.theme === 'viewFlowChart') {
      this.viewFlowChartByProcInstId();
    } else {
      this.processForecast();
    }
  }

  tabChange(event: any) {
    this.procInstId = event.nextId;
    this.viewFlowChart();
    this.flowChart.reloadBpmnModel();
  }

  closeDialog() {
    this.dialog.close();
  }

  /**
   * 查看子流程图
   * @param actInst 活动实例 
   * @param superProcess 父流程 
   */
  viewChild(actInst: ActivityInstanceSlim, superProcess: ProcessInstance) {
    this.service.getMutiChildInstance(actInst, superProcess.id).subscribe((re: ProcessInstance[]) => {
      if (this.chartService && re && re.length) {
        if (re.length == 1) {//单个子流程
          this.chartService.viewFlowChartByDialog(re[0].id, this.mode);
        } else {//多实例子流程
          this.chartService.viewMutiInstanceFlowChartByDialog(re, this.mode);
        }
      } else {
        throw Error('请升级查看流程公共包实现联查子流程图功能');
      }
    });
  }

  modeSwitch() {
    if (this.mode === 'complete') {
      this.mode = 'simulation';
      this.ifForecast = 'true';
      this.modeButton = this.service.getI18nValue('static.flowchart.complete');
      this.service.getForecastProcessByProcInstId(this.procInstId).subscribe(r => {
        this.actInstList = r.activityInstanceSlims;
        this.transInsList = r.transitionInstanceSlims;
        this.flowChart.switchMode({
          mode: 'simulation',
          actiInstList: r.activityInstanceSlims,
          transInsList: r.transitionInstanceSlims
        });
      });
    } else {
      this.mode = 'complete';
      this.ifForecast = 'false';
      this.modeButton = this.service.getI18nValue('static.flowchart.simulation');
      this.service.getCompleteProcessInfoByProcInstId(this.procInstId).subscribe(r => {
        this.actInstList = r.activityInstanceSlims;
        this.transInsList = r.transitionInstanceSlims;
        this.flowChart.switchMode({
          mode: 'complete',
          actiInstList: r.activityInstanceSlims,
          transInsList: r.transitionInstanceSlims
        });
      });
    }
  }

  viewLogs(data: any) {
    this.type = data.type;
    this.actDefId = data.actiDefId;
  }

  viewFlowChartByProcInstId() {
    this.content = '';
    if (this.procInstId) {
      if (this.mode === 'complete') {
        forkJoin(
          this.service.getProcInstanceById(this.procInstId),
          this.service.getBpmnModelbyProcInstId(this.procInstId),
          this.service.getCompleteProcessInfoByProcInstId(this.procInstId))
          .subscribe((data: any[]) => {
            this.processInstance = data[0];
            this.content = JSON.stringify(data[1]);
            this.actInstList = data[2].activityInstanceSlims;
            this.transInsList = data[2].transitionInstanceSlims;
            this.loadFlowChart();
          });
      } else {
        forkJoin(
          this.service.getProcInstanceById(this.procInstId),
          this.service.getBpmnModelbyProcInstId(this.procInstId),
          this.service.getForecastProcessByProcInstId(this.procInstId))
          .subscribe((data: any[]) => {
            this.processInstance = data[0];
            this.content = JSON.stringify(data[1]);
            this.actInstList = data[2].activityInstanceSlims;
            this.transInsList = data[2].transitionInstanceSlims;
            this.loadFlowChart();
          });
      }
    }
  }

  processForecast() {
    this.content = '';
    this.mode = 'simulation';
    if (this.processForecastPayload.processDefinitionId && this.processForecastPayload.dataId) {
      forkJoin(
        this.service.getBpmnModelbyProcDefId(this.processForecastPayload.processDefinitionId),
        this.service.getForecastProcessByPayload(this.processForecastPayload))
        .subscribe((data: any[]) => {
          this.content = JSON.stringify(data[0]);
          this.actInstList = data[1].activityInstanceSlims;
          this.transInsList = data[1].transitionInstanceSlims;
          this.loadFlowChart();
        });
    }
  }

  viewForm(procInstId: string, actInstId: string, bizInstId: string) {
    if (procInstId) {
      this.service.getFormInfoByActInstId(procInstId, actInstId).subscribe((re: any) => {
        const formInfo = re;
        if (!formInfo || !formInfo.appId) {
          if (this.message) {
            this.message.info('找不到单据，请联系管理员查看原因！');
          }
          return;
        }
        const options: AppOptions = {
          appType: 'menu',
          funcId: formInfo.appId,
          appId: '',
          appEntrance: '',
          tabId: bizInstId,
          isNewTab: true
        };
        // 传工作流上下文参数
        const parameters = new Map<string, any>();
        parameters.set('procInstId', procInstId);
        parameters.set('actInstId', actInstId);
        formInfo.parameters.forEach((item: any) =>
          parameters.set(item.code, item.value)
        );
        options.queryStringParams = parameters;
        if (this.frameworkSvc) {
          this.frameworkSvc.openMenu(options);
        } else {
          throw Error('框架服务不存在！无法联查！');
        }
      });
    }
  }

  retryAifCreation(procInstId: string, actInstId: string, bizInstId: string) {
    if (procInstId) {
      const l = this.loading.show();
      this.service.retryAifCreation(procInstId, actInstId, bizInstId).subscribe(
        (re: any) => {
          l.close();
          this.notify.success("重试成功");
          this.viewFlowChart();
        },
        (err) => {
          l.close();
          setTimeout(() => {
            //todo 确定异常结构, 目前采用兼容取值方式
            this.message.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
          }, 300);
          throw err;
        }
      );
    }
  }

  loadFlowChart() {
    if (this.content) {
      this.flowChart.load({
        processInstance: this.processInstance,
        content: this.content,
        actiInstList: this.actInstList,
        transInsList: this.transInsList,
        mode: this.mode
      });
    }
  }

  fill() {
    this.cls = 'd-flex flex-fill h-100 f-utils-absolute-all';
  }

}
